module.exports = __webpack_public_path__ + "img/closet_footer_mobile.0203cca7.png";